// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.several-suppliers .processing__radios-wrapper {\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  margin-top: 0;\n}\n.several-suppliers .processing__radio {\n  width: 100%;\n  margin-top: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
